import { styled } from 'linaria/react';
import { theme } from '../Theme';
const Outer = styled('div')`
  margin: auto;
  width: 100%;
  max-width: ${props => (props.maxWidth ? '40rem' : 'initial')};
  height: 100%;
  position: relative;
`;

const YoutubeWrapper = styled('div')`
  position: relative;
  padding-bottom: 100%;
  height: 0;
  overflow: hidden;
  &.isPlaying {
    z-index: 4;
  }
  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
    .cover {
      display: block;
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 45px; /* Make room for youtube controls */
      cursor: pointer;
      left: 0;
      z-index: 2;

      ${theme.above.md} {
        &.hasPlayed {
          display: none;
        }
      }
    }
    
    
  }
`;
const style = { Outer, YoutubeWrapper };

export default style;
